import { Outlet, useParams, useLocation } from "react-router-dom";
import { useEffect, useLayoutEffect, useRef } from "react";

import { useInTheGame } from "../utils/InTheGameContexte.tsx";

import Container from "./Container.tsx";
import Banner from "./Banner.tsx";

import gsap from "gsap";

function ModeLayout() {
  const { id } = useParams();

  const bannerRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const title =
    id === "entrainement"
      ? "Entraînement"
      : id === "expert"
      ? "Mode expert"
      : "Mode classique";

  const { toggleGame } = useInTheGame();
  useEffect(() => {
    toggleGame(true);
  }, [toggleGame]);

  useLayoutEffect(() => {
    if (bannerRef.current) {
      const tl = gsap.timeline();
      gsap.set(bannerRef.current.querySelector("h1"), {
        transformOrigin: "top left",
      });

      // Animer l'échelle du texte
      gsap.set(bannerRef.current.querySelector("h1"), {
        opacity: 0,
      });
      // Définir explicitement transform-origin avant de commencer les animations
      gsap.set(bannerRef.current, {
        transformOrigin: "top top",
        width: "100%",
        height: 0,
      });

      // Animer la largeur et la hauteur
      tl.to(bannerRef.current, {
        duration: 0.7,
        width: "100%",
        height: "4.5rem",
        ease: "power3.out",
      });

      // Animer l'échelle du texte
      tl.to(
        bannerRef.current.querySelector("h1"),

        {
          opacity: 1,

          duration: 0,
          ease: "power3.out",
        }
      ).to(document.querySelectorAll(".animation-item"), {
        autoAlpha: 1,
        xPercent: 0,
        duration: 1,
        stagger: 0.1,
        ease: "power2.out",
      });
    }
  }, [location.pathname]);

  return (
    /*  <div
      style={{
        backgroundColor: "#FFFFFF",
        overflow: "hidden",
        width: "100%",
        height: "100%",
      }}
    > */
    <Container color="blue">
      <Banner color={`${id === "expert" ? "red" : "blue"}`} ref={bannerRef}>
        <h1 className="banner--mode">{title}</h1>
      </Banner>
      <Outlet />
    </Container>
    /*   </div> */
  );
}

export default ModeLayout;
